export default __webpack_public_path__ + "static/media/ans_sulamerica.5962fbe0.png";